import React from 'react';

import StarIcon from '@material-ui/icons/Star';

const RatingIcon: React.FC<{}> = () => {
  return <StarIcon fontSize="small" style={{ color: '#F3A100' }} />;
};

export default RatingIcon;
